<app-split [id]="splitComponentId">
  <div class="annex-signature-container">
    <div class="content-card">
      <div class="page-header">
        <h1 class="page-title">{{ 'Annex.SignatureTitle' | translate }}</h1>

        @if (annexData) {
          <div class="annex-document-actions">
            <button mat-raised-button color="accent" type="button" (click)="onDownloadAnnexClick()">
              <mat-icon>download</mat-icon>
              {{ 'Annex.DownloadAnnex' | translate }}
            </button>
          </div>
        }
      </div>

      @if (annexData) {
        <!-- Progres podpisów -->
        <div class="approval-progress-section">
          <app-annex-approval-progress [signatureSteps]="signatureSteps"> </app-annex-approval-progress>
        </div>

        <app-annex-summary
          [agreement]="annexData.WorkerAgreement"
          [dataForAnnex]="annexData.WorkerAgreement"
          [annexData]="annexData.Annex"
        ></app-annex-summary>

        @if (annexData) {
          <div class="annex-actions">
            @if (isViewMode) {
              <div class="view-mode-message">
                <div class="message-content">
                  <mat-icon>info_outline</mat-icon>
                  <span>{{ 'Annex.NotAwaitingYourSignature' | translate }}</span>
                </div>
                <div class="back-to-agreement-button">
                  <a
                    mat-raised-button
                    color="accent"
                    type="button"
                    [routerLink]="['/workers', workerId, 'employmentType', employmentTypeId, 'agreements', agreementId, 'details']"
                  >
                    <mat-icon>arrow_back</mat-icon>
                    {{ 'Annex.BackToAgreement' | translate }}
                  </a>
                </div>
              </div>
            } @else {
              <button mat-raised-button color="primary" type="button" class="sign-button" (click)="onSignClick()">
                <mat-icon>draw</mat-icon>
                {{ 'Annex.SignAnnex' | translate }}
              </button>
            }
          </div>
        }
      }
    </div>
  </div>
</app-split>
